<template>
  <v-container>
    <h3 class="font-weight-bold text--secondary mx-2 mb-4">
      Disponibilidad de créditos para empresas convenio
    </h3>
    <v-card
      outlined
      v-for="disponibilidad in disponibilidadPorConvenio"
      :key="disponibilidad.convenioId"
      class="mb-4"
    >
      <v-card-title class="py-3">
        <v-row class="justify-space-between align-center px-2">
          <h5 class="text--secondary">
            {{ disponibilidad.convenio.razon_social }}
          </h5>

          <v-chip
            :color="disponibilidad.disponible ? 'green' : 'red'"
            text-color="white"
            class="my-2 mb-4 px-12"
            label
          >
            {{ disponibilidad.disponible ? 'Disponible' : 'No Disponible' }}
          </v-chip>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-icon
              :color="disponibilidad.fechaIngresoValida ? 'green' : 'red'"
            >
              {{
                disponibilidad.fechaIngresoValida ? 'check_circle' : 'cancel'
              }}
            </v-icon>

            <span class="pa-3"
              >La fecha de ingreso del empleado debe ser mayor o igual a
              {{ disponibilidad.convenio.plazo_minimo_credito }} mes(es)
            </span>
          </v-col>

          <v-col cols="12">
            <v-icon :color="disponibilidad.bloqueosCartera ? 'red' : 'green'">
              {{ disponibilidad.bloqueosCartera ? 'cancel' : 'check_circle' }}
            </v-icon>

            <span class="pa-3">
              El empleado no debe contar con bloqueos por cartera
            </span>
          </v-col>

          <v-col cols="12">
            <v-icon
              :color="disponibilidad.contratoHastaValido ? 'green' : 'red'"
            >
              {{
                disponibilidad.contratoHastaValido ? 'check_circle' : 'cancel'
              }}
            </v-icon>

            <span class="pa-3"
              >La fecha de finalización de contrato del empleado debe ser mayor
              o igual a
              {{ disponibilidad.convenio.plazo_contrato_finalizar }} mes(es)
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment';

import { CONTRATO } from '../../../../constants/tipoContrato.js';

export default {
  name: 'DisponibilidadCreditos',

  props: {
    convenios: {
      type: Array,
      required: true,
    },

    empleado: {
      type: Object,
      required: true,
    },
  },

  computed: {
    disponibilidadPorConvenio() {
      return this.convenios.map(convenio => {
        const fechaIngresoValida = this.verificarFechaIngreso(convenio);
        const contratoHastaValido = this.verificarContratoHasta(convenio);
        const bloqueosCartera = this.verificarBloqueoCartera();

        const disponible =
          fechaIngresoValida && contratoHastaValido && !bloqueosCartera;

        return {
          convenioId: convenio._id,
          convenio,
          disponible,
          fechaIngresoValida,
          contratoHastaValido,
          bloqueosCartera,
        };
      });
    },
  },

  methods: {
    verificarFechaIngreso(convenio) {
      const fechaIngreso = moment(this.empleado.data.FechaIngreso);
      const fechaActual = moment().utc();
      const fechaMinimaRequerida = fechaActual
        .clone()
        .subtract(convenio.plazo_minimo_credito, 'months')
        .add(1, 'days');

      return fechaIngreso.isSameOrBefore(fechaMinimaRequerida);
    },

    verificarContratoHasta(convenio) {
      const tipoContratoId =
        this.empleado.data.TipoContrato?._id ?? this.empleado.data.TipoContrato;
      const tiposContratoEspecial = [
        CONTRATO.TERMINO_FIJO,
        CONTRATO.OPS,
        CONTRATO.APRENDIZAJE,
      ];
      const fechaContratoHasta = moment.utc(
        this.empleado.data.FechaContratoHasta
      );
      const fechaLimite = moment
        .utc()
        .add(convenio.plazo_contrato_finalizar, 'months');

      if (!tiposContratoEspecial.includes(tipoContratoId)) {
        return true;
      }
      if (!fechaContratoHasta.isValid()) return false;

      return fechaContratoHasta.isSameOrAfter(fechaLimite, 'day');
    },

    verificarBloqueoCartera() {
      return this.empleado.data.Bloqueado === true;
    },
  },
};
</script>
